import { Injectable } from '@angular/core';
import { GetAllResponse } from '../model/restful-api.model';
import { environment } from 'src/environments/environment';
import { API_URL } from '../enums/api-enums';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { Observable } from 'rxjs';
import { SupportEmail } from '../model/support-email.model';

@Injectable({
  providedIn: 'root'
})

export class EmailSupportService {
  constructor(
    private utilities: UtilitiesService) { }

  postEmailSupport(id, body): Observable<GetAllResponse<SupportEmail>> {
    const url = environment.portalURL + API_URL.APPLICATION_TRAINING_URL + `/${id}/email`;
    return this.utilities.req.httpPut<GetAllResponse<SupportEmail>>(url, body);
  }

  getEmailSupportByID(id): Observable<GetAllResponse<SupportEmail>> {
    const url = environment.portalURL + API_URL.APPLICATION_TRAINING_URL + `${id}`;
    return this.utilities.req.httpGet<GetAllResponse<SupportEmail>>(url);
  }

  getEmailSupport(): Observable<GetAllResponse<SupportEmail>> {
    const url = environment.portalURL + API_URL.APPLICATION_TRAINING_URL;
    return this.utilities.req.httpGet<GetAllResponse<SupportEmail>>(url);
  }

  deleteEmailSupport(sso): Observable<GetAllResponse<SupportEmail>> {
    const url = environment.portalURL + API_URL.APPLICATION_TRAINING_URL + `/${sso}`;
    return this.utilities.req.httpDelete<GetAllResponse<SupportEmail>>(url);
  }

  editEmailSupport(sso, body): Observable<GetAllResponse<SupportEmail>> {
    const url = environment.portalURL + API_URL.APPLICATION_TRAINING_URL + `/${sso}`;
    return this.utilities.req.httpPut<GetAllResponse<SupportEmail>>(url, body);
  }

}
